// extracted by mini-css-extract-plugin
module.exports = {"CatForm":"CatForm_CatForm__3cHRx"};